import { render, staticRenderFns } from "./1to7.vue?vue&type=template&id=3038d0d7&"
import script from "./1to7.vue?vue&type=script&lang=js&"
export * from "./1to7.vue?vue&type=script&lang=js&"
import style0 from "./1to7.vue?vue&type=style&index=0&id=3038d0d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports